import { createFileRoute } from "@tanstack/react-router";

import { legalRoute } from "./legal/-components/legalRoute";

export const Route = createFileRoute("/fair-usage-policy")(
  legalRoute("fair-usage-policy")
);
